<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row mb-2">
        <div class="col-2">
          {{ $t('shared.component.table.field.name') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ required: true, max: 40 }">
            <i-input v-model="form.name" />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      :disabled="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import { DataBaseGroupService } from '@db/services/GroupService';

  export default {
    components: {
      BaseModal
    },

    props: {
      id: {
        type: [Number, String],
        default: undefined
      },

      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      is_button_loading: false
    }),

    watch: {
      item: {
        handler: function (val) {
          this.form = defaultsDeep(pick(val, ['name']), {
            name: ''
          });
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;

            const request = this.id
              ? DataBaseGroupService.editItem(this.id, this.form)
              : DataBaseGroupService.createItem(this.form);

            request
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.is_button_loading = false;
                this.$noty.server_error(e);
                this.$emit('fail', e);
              });
          }
        });
      }
    }
  };
</script>
